"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewSplit = function NewSplit() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.25 15.5V8.30383L1.99997 3.0538V5.99998H0.5V0.5H5.99997V1.99998H3.0538L8.74995\n7.69613V15.5H7.25ZM10.5038 6.58075L9.4192 5.49615L12.9461\n1.99998H9.99998V0.5H15.5V5.99998H14V3.0538L10.5038 6.58075Z",
    fill: "#6E6D71"
  }));
};
var _default = NewSplit;
exports.default = _default;